import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H5 from '@base/H5/H5';
import P2 from '@base/P2/P2';
import { Spacings } from '@styles/index';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_12B};
`;

const InProgress = ({ title, description }) => (
  <Wrapper>
    <H5>{title}</H5>
    <P2>{description}</P2>
  </Wrapper>
);

export default InProgress;

InProgress.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};
